//
export const ALL_COUNTRY_LIST = 'ALL_COUNTRY_LIST'
export const ALL_COUNTRY_LIST_SUCCESS = 'ALL_COUNTRY_LIST_SUCCESS'
